module.exports = __webpack_public_path__ + "static/img/theme2.2483db2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/theme2.jpg
// module id = q34V
// module chunks = 1